import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import textWrap from '@src/utils/text-wrap';
import Page from '@src/components/page';
import Button from '@src/components/button';
import BackTopFooter from '@src/business-components/backtop-footer';
import TabMenu from '../components/tab-menu';
import Store from './store';
import { mechaData } from './mechaUnit';
const styles = require('./index.less');

const MechaUnit = ({ store, onBack }) => {
  store.use();

  const { mecha_img: mechaImg, driver_img: driverImg, bg_kv: bgKv } = store.mechaCmsData || {};

  const renderWrapText = originText => {
    if (!originText) return '';
    const textList = textWrap(originText);
    return textList.map((txt, idx) => <div key={idx}>{txt}</div>);
  };

  return (
    <React.Fragment>
      <Page className={cx(styles.MechaUnitRoot, 'page-main')}>
        <div className={styles.unitContainer}>
          <div className={cx(styles.btnBack)}>
            <Button className={styles.btnBackInner} onClick={onBack} style={{ backgroundImage: `url(${mechaData.btnBack})` }} />
          </div>
          <div className={styles.topBox} style={{ backgroundImage: `url(${bgKv})` }}>
            <div className={styles.pageIconBox}>
              <div className={styles.pageIcon1} />
              <div className={styles.pageIcon2} />
            </div>

            <div className={styles.line1} />
            <img className={styles.nameBox} src={mechaData.mechaName} alt="" />
            <div className={styles.topRight}>
              <div className={styles.btnPlayBox} onClick={store?.playVideo}>
                <div className={styles.btnPlay} />
              </div>
            </div>
            <div className={styles.bottomLIne} />
          </div>
          <div className={styles.airframeBox}>
            {mechaData ? (
              <React.Fragment>
                <div className={styles.structureImg} style={{ backgroundImage: `url(${mechaImg})` }} />
                <div className={styles.per} style={{ backgroundImage: `url(${driverImg})` }} />
              </React.Fragment>
            ) : null}
          </div>
          <div className={styles.containerBox}>
            <div className={styles.containerBoxBg} />
            <div className={cx(styles.contontBox)}>
              <div className={styles.leftBox}>
                <div className={styles.leftContent}>
                  <div className={styles.leftTitle} style={{ backgroundImage: `url(${mechaData.driverStoryTitle})` }} />
                  <div className={styles.storyBox}>
                    <div className={styles.driversNameBox}>
                      <div className={styles.driverName}>{mechaData.driverName}</div>
                      <div className={styles.driverType}>{mechaData.driverType}</div>
                    </div>
                    <div className={styles.badge}>
                      <div className={styles.iconBadge} />
                    </div>
                    <div className={styles.basicInfo}>
                      <div className={styles.title}>{mechaData.basicInfoTitle}</div>
                      <div className={styles.infoBox}>
                        <div className={styles.info}>{mechaData.driversSex}</div>
                        <div className={styles.info}>{mechaData.driversBirthplace}</div>
                        <div className={styles.info}>{mechaData.driversStructure}</div>
                      </div>
                    </div>
                    <div className={cx(styles.basicInfo, styles.experience)}>
                      <div className={styles.title}>{mechaData.roleExperSubTitle}</div>
                      <div className={styles.infoBox}>
                        <div className={styles.info}>{renderWrapText(mechaData.driversRoleExperText)}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.driverVoiceBox}>
                  <div className={styles.pageIconBox}>
                    <div className={styles.pageIcon1} />
                    <div className={styles.pageIcon2} />
                  </div>
                  <div className={styles.driverVoiceTitle}>{mechaData.driverVoiceTitle}</div>
                  {store?.cvTab?.length > 0 && <div className={styles.cr}>{store?.cvTab[store?.cvTabIndex].name}</div>}

                  <div className={cx(styles.change)} style={{ backgroundImage: `url(${mechaData.cvTab[store.cvTabIndex]})` }}>
                    {store.cvTab?.map((item, tabIndex) => (
                      <div
                        key={tabIndex}
                        className={cx(styles.changeItem, styles[`changeItem-${item.value}`], store?.cvTabIndex === tabIndex && styles.on)}
                        onClick={() => store?.switchCvTab(tabIndex, item.langType)}
                      >
                        {item.lang}
                      </div>
                    ))}
                  </div>
                  <ul className={styles.voiceUl}>
                    {store.cvList?.map((item, index) => {
                      return (
                        <li key={index} className={cx(styles.voiceLi, item.isPlay && styles.active)}>
                          <div className={styles.btnPlay} onClick={() => store?.onClickPlayRoleAudio(index)} />
                          <div className={styles.voiceTitle}>{item.title}</div>
                          {item.isPlay && (
                            <div className={styles.soundBox}>
                              <img className={styles.screen} src={mechaData.audioScreen} alt="" />
                            </div>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
              <div className={styles.rightBox}>
                <div className={styles.rightContent}>
                  <div className={styles.storyBox}>
                    <div className={styles.driversNameBox}>
                      <div className={styles.driverName}>{mechaData.mechaInfoType}</div>
                    </div>
                    <div className={styles.basicInfo}>
                      <div className={styles.title}>{mechaData.basicInfoTitle}</div>
                      <div className={styles.infoBox}>
                        <div className={styles.info}>{mechaData.mechaInfoNums}</div>
                        <div className={cx(styles.info, styles.headHigh)}>{mechaData.mechaInfoHeadHigh}</div>
                        <div className={styles.info}>{mechaData.mechaInfoEmptyWeight}</div>
                        <div className={styles.info}>{mechaData.mechaInfoTotal}</div>
                      </div>
                    </div>
                    <div className={cx(styles.basicInfo, styles.experience)}>
                      <div className={styles.pageIconBox}>
                        <div className={styles.pageIcon1} />
                        <div className={styles.pageIcon2} />
                      </div>
                      <div className={styles.title}>{mechaData.mechaStorySubTitle}</div>
                      <div className={cx(styles.infoBox, styles.infoBoxjibing)}>
                        <div className={styles.info}>{renderWrapText(mechaData.mechaInfoStory)}</div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.rightTitle} style={{ backgroundImage: `url(${mechaData.mechaInfoTitle})` }} />
                </div>
                <div className={cx(styles.carmakers)}>
                  <div className={styles.pageIconBox}>
                    <div className={styles.pageIcon1} />
                    <div className={styles.pageIcon2} />
                  </div>
                  <div className={styles.carmakersContBox}>
                    <div className={styles.title}>{mechaData.manufacturerGruopCh}</div>
                    <div className={styles.badge}>
                      <img className={styles.maLogo} src={mechaData.maLogo} alt="生厂商logo" />
                    </div>
                  </div>
                  <div className={styles.carmakersTitle} style={{ backgroundImage: `url(${mechaData.manufacturerTitle})` }} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <TabMenu key={mechaImg} store={store.tabMenuStore} />
        <BackTopFooter theme="yellow" />
      </Page>
    </React.Fragment>
  );
};

export default wrapStore(MechaUnit, Store);
